var map = {
	"./LayoutDetail.vue": "SlwC",
	"./LayoutList.vue": "u5LK"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "/gxA";


//////////////////
// WEBPACK FOOTER
// ./src/components/layouts nonrecursive Layout[\w-]+\.vue$
// module id = /gxA
// module chunks = 27